import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { logger } from '~/utils/func/logger';

import { GetPaymentResponse } from './entities/responses/getPaymentResponse';
import en from './locales/en.json';
import fr from './locales/fr.json';
import zh from './locales/zh.json';
import { CryptoService } from './services/CryptoService';

export const languages = ['fr', 'en', 'zh'];

const initializeI18n = () => {
  const supportedLngs = languages.map(lang => lang.toLowerCase());

  const crypto = new CryptoService();
  crypto.setSecretKey(process.env.REACT_APP_APPLI_SECKEY ?? '');

  let defaultLanguage = 'en';

  try {
    const encryptedData = localStorage.getItem('data') as string;
    const decryptData = crypto.decryptData(encryptedData) as GetPaymentResponse;

    if (decryptData && decryptData.data && decryptData.data.language) {
      defaultLanguage = decryptData.data.language;
    }
  } catch (error: any) {
    logger.error('i18n init error', error instanceof Error ? error : undefined, { prefix: 'i18n', data: error });
  }

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      debug: false,
      defaultNS: 'translations',
      detection: {
        lookupQuerystring: 'lng',
        order: ['querystring', 'localStorage'],
      },
      fallbackLng: defaultLanguage,
      supportedLngs,
      keySeparator: false,
      ns: ['translations'],
      react: {
        useSuspense: true,
      },
      resources: { fr, en, zh },
      saveMissing: true,
      saveMissingTo: 'all',
    });

  return i18n;
};

export default initializeI18n;
